import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { Funcao } from '../../models/funcao';

@Component({
  selector: 'app-funcao-table',
  templateUrl: './funcao-table.component.html',
  styleUrls: ['./funcao-table.component.scss']
})
export class FuncaoTableComponent implements OnInit {

  @Input() funcoes$: BehaviorSubject<Funcao[]> = new BehaviorSubject<Funcao[]>([]);

  @Output() funcaoRemovida: EventEmitter<Funcao> = new EventEmitter<Funcao>();

  displayedColumns: string[] = ['funcao', 'actions'];

  constructor() { }

  ngOnInit(): void {
  }

  removerFuncao(funcao: Funcao): void {
    this.funcaoRemovida.emit(funcao);
  }
}
